import React, { useEffect, useState } from "react";
import "../../styles/offsetting.css";
import loader2 from "../../images/loader_2.gif";
import ApiService from "../../api/apiService";
import showSwal from "../swal";
import { common } from "../../util/common";
import { convertTo12HourPlusDateFormat } from "../../util/helperFunctions";
import "../../styles/ccar-form.css";

console.log("=== CCAR FORM VERSION 2 ===");

function CcarForm(props) {
  console.log("CCAR PROPS:", props);

  const {
    formDetails,
    setReferenceId,
    setDateAndTime,
    setFormSubmitted,
  } = props;

  const [isSubmitting, setSubmitting] = useState(false);
  const [attachments, setAttachments] = useState([]);

  const [formData, setFormData] = useState({
    issuedTo: "",
    issuedToOther: "",
    ncSource: "",
    warehouse: "",
    warehouseOther: "",
    referenceNumber: "",
    ncDescription: "",
  });

  const {
    issuedTo,
    issuedToOther,
    ncSource,
    warehouse,
    warehouseOther,
    referenceNumber,
    ncDescription,
  } = formData;

  const departments = [
    "Finance",
    "Sales",
    "Warehouse / Supply Chain",
    "Customer Fulfillment and Delivery",
    "Other",
  ];

  const ncSources = [
    "Delivery (Customer Complaint)",
    "Quality (Customer Complaint)",
    "Audit",
    "Incident Report",
  ];

  const warehouses = [
    "Bacolod",
    "Bohol",
    "Cavite Depot",
    "NCR",
    "Ormoc",
    "Starport Mindoro",
    "Tacloban",
    "Top Armada Mindoro",
    "Other",
  ];

  const handleImageChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);

    setAttachments((previousAttachments) => [
      ...previousAttachments,
      ...selectedFiles,
    ]);

    // Allows the user to select the same file again.
    event.target.value = "";
  };

  const removeAttachment = (index) => {
    setAttachments((previousAttachments) =>
      previousAttachments.filter(
        (_, attachmentIndex) => attachmentIndex !== index,
      ),
    );
  };

  const handleDataChange = (key, value) => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      [key]: value,
    }));
  };

  const handleIssuedToChange = (value) => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      issuedTo: value,
      issuedToOther:
        value === "Other"
          ? previousFormData.issuedToOther
          : "",
    }));
  };

  const handleWarehouseChange = (value) => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      warehouse: value,
      warehouseOther:
        value === "Other"
          ? previousFormData.warehouseOther
          : "",
    }));
  };

  const showIssuedToDropdown = () => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      issuedTo: "",
      issuedToOther: "",
    }));
  };

  const showWarehouseDropdown = () => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      warehouse: "",
      warehouseOther: "",
    }));
  };

  const validateForm = () => {
    if (!issuedTo) {
      showSwal("Please select a department.");
      return false;
    }

    if (
      issuedTo === "Other" &&
      !issuedToOther.trim()
    ) {
      showSwal("Please enter the department name.");
      return false;
    }

    if (!ncSource) {
      showSwal(
        "Please select the Nonconformity source.",
      );
      return false;
    }

    if (!warehouse) {
      showSwal("Please select a warehouse.");
      return false;
    }

    if (
      warehouse === "Other" &&
      !warehouseOther.trim()
    ) {
      showSwal("Please enter the warehouse name.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    console.log("formDetails:", formDetails);
    console.log("formDetails?.id:", formDetails?.id);

    if (!formDetails?.id) {
      console.error(
        "formDetails or formDetails.id is undefined",
      );

      showSwal(
        "Unable to identify the selected CCAR form.",
      );

      return;
    }

    if (!validateForm()) {
      return;
    }

    /*
     * Use the custom input when Other is selected.
     * Otherwise, use the dropdown value.
     */
    const finalIssuedTo =
      issuedTo === "Other"
        ? issuedToOther.trim()
        : issuedTo.trim();

    const finalWarehouse =
      warehouse === "Other"
        ? warehouseOther.trim()
        : warehouse.trim();

    const requestFormData = new FormData();

    requestFormData.append(
      "issued_to",
      finalIssuedTo,
    );

    requestFormData.append(
      "nc_source",
      ncSource,
    );

    requestFormData.append(
      "warehouse",
      finalWarehouse,
    );

    requestFormData.append(
      "reference_number",
      referenceNumber.trim(),
    );

    requestFormData.append(
      "nc_description",
      ncDescription.trim(),
    );

    attachments.forEach((file) => {
      requestFormData.append(
        "prospecting_images",
        file,
      );
    });

    setSubmitting(true);

    try {
      const response =
        await ApiService.forms.submitCCARRequest(
          formDetails.id,
          requestFormData,
        );

      console.log("CCAR RESPONSE:", response);

      if (!response) {
        showSwal(
          "No response received from server.",
        );
        return;
      }

      const { success, ccar_request } = response;

      if (!success) {
        showSwal(
          common.errors.SUBMIT_OFFSET_FORM_ERROR,
        );
        return;
      }

      if (!ccar_request) {
        showSwal(
          "CCAR request was submitted, but the response data is incomplete.",
        );
        return;
      }

      setReferenceId(
        ccar_request.reference_id,
      );

      setDateAndTime(
        convertTo12HourPlusDateFormat(
          ccar_request.createdAt,
        ),
      );

      setFormSubmitted(true);
    } catch (error) {
      console.error(
        "CCAR submission error:",
        error,
      );

      showSwal(
        "Failed to submit CCAR request.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    console.log(
      "CCAR formDetails:",
      formDetails,
    );

    if (formDetails) {
      console.log(
        "CCAR ID:",
        formDetails.id,
      );
    }
  }, [formDetails]);

  return (
    <div className="epr-form-container">
      <div className="epr-title">
        <h3>
          Customer Corrective Action Request Form
        </h3>
      </div>

      <div className="epr-form-panel">
        <form
          className="epr-form-body"
          onSubmit={handleSubmit}
        >
          <div className="epr-form-groupings">
            <div className="epr-form-group">
              {/* Issued To */}
              <div className="epr-form-fields-prospecting">
                <label htmlFor="ccar-issued-to">
                  Issued to
                  <span className="epr-required">
                    *
                  </span>
                </label>

                {issuedTo !== "Other" ? (
                  <select
                    id="ccar-issued-to"
                    value={issuedTo}
                    disabled={isSubmitting}
                    onChange={(event) =>
                      handleIssuedToChange(
                        event.target.value,
                      )
                    }
                  >
                    <option value="">
                      Select Department
                    </option>

                    {departments.map(
                      (department) => (
                        <option
                          key={department}
                          value={department}
                        >
                          {department}
                        </option>
                      ),
                    )}
                  </select>
                ) : (
                  <div className="ccar-other-field-container">
                    <input
                      id="ccar-issued-to"
                      type="text"
                      value={issuedToOther}
                      placeholder="Enter department name"
                      disabled={isSubmitting}
                      autoFocus
                      onChange={(event) =>
                        handleDataChange(
                          "issuedToOther",
                          event.target.value,
                        )
                      }
                    />

                    <button
                      type="button"
                      className="ccar-back-to-select-btn"
                      disabled={isSubmitting}
                      onClick={showIssuedToDropdown}
                    >
                      <i className="fa fa-arrow-left" />
                      Back to department list
                    </button>
                  </div>
                )}
              </div>

              {/* NC Source */}
              <div className="epr-form-fields-prospecting">
                <label htmlFor="ccar-nc-source">
                  NonConformity (NC) Source
                  <span className="epr-required">
                    *
                  </span>
                </label>

                <select
                  id="ccar-nc-source"
                  value={ncSource}
                  disabled={isSubmitting}
                  onChange={(event) =>
                    handleDataChange(
                      "ncSource",
                      event.target.value,
                    )
                  }
                >
                  <option value="">
                    Select Source
                  </option>

                  {ncSources.map((source) => (
                    <option
                      key={source}
                      value={source}
                    >
                      {source}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="epr-form-group">
              {/* Warehouse */}
              <div className="epr-form-fields-prospecting">
                <label htmlFor="ccar-warehouse">
                  Warehouse
                  <span className="epr-required">
                    *
                  </span>
                </label>

                {warehouse !== "Other" ? (
                  <select
                    id="ccar-warehouse"
                    value={warehouse}
                    disabled={isSubmitting}
                    onChange={(event) =>
                      handleWarehouseChange(
                        event.target.value,
                      )
                    }
                  >
                    <option value="">
                      Select Warehouse
                    </option>

                    {warehouses.map(
                      (warehouseItem) => (
                        <option
                          key={warehouseItem}
                          value={warehouseItem}
                        >
                          {warehouseItem}
                        </option>
                      ),
                    )}
                  </select>
                ) : (
                  <div className="ccar-other-field-container">
                    <input
                      id="ccar-warehouse"
                      type="text"
                      value={warehouseOther}
                      placeholder="Enter warehouse name"
                      disabled={isSubmitting}
                      autoFocus
                      onChange={(event) =>
                        handleDataChange(
                          "warehouseOther",
                          event.target.value,
                        )
                      }
                    />

                    <button
                      type="button"
                      className="ccar-back-to-select-btn"
                      disabled={isSubmitting}
                      onClick={showWarehouseDropdown}
                    >
                      <i className="fa fa-arrow-left" />
                      Back to warehouse list
                    </button>
                  </div>
                )}
              </div>

              {/* Reference Number */}
              <div className="epr-form-fields-prospecting">
                <label htmlFor="ccar-reference-number">
                  Customer / Audit Reference Number
                </label>

                <input
                  id="ccar-reference-number"
                  type="text"
                  value={referenceNumber}
                  disabled={isSubmitting}
                  onChange={(event) =>
                    handleDataChange(
                      "referenceNumber",
                      event.target.value,
                    )
                  }
                />
              </div>
            </div>

            <div className="epr-form-group">
              <div className="epr-section-card">
                <div className="epr-title">
                  <h3>Pagtugon sa NC</h3>
                </div>

                <div className="epr-form-group">
                  <div className="epr-form-fields-prospecting">
                    <label htmlFor="ccar-nc-description">
                      A. Pagsalaysay sa Paltos
                      (NC) na Delivery or Quality
                    </label>

                    <textarea
                      id="ccar-nc-description"
                      value={ncDescription}
                      disabled={isSubmitting}
                      onChange={(event) =>
                        handleDataChange(
                          "ncDescription",
                          event.target.value,
                        )
                      }
                    />
                  </div>
                </div>

                {/* Attachments */}
                <div className="epr-form-fields-prospecting">
                  <label htmlFor="ccar-upload">
                    Attachments
                  </label>

                  <input
                    id="ccar-upload"
                    type="file"
                    multiple
                    accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                    style={{
                      display: "none",
                    }}
                    disabled={isSubmitting}
                    onChange={handleImageChange}
                  />

                  <button
                    type="button"
                    className="ccar-add-file-btn"
                    disabled={isSubmitting}
                    onClick={() => {
                      document
                        .getElementById(
                          "ccar-upload",
                        )
                        ?.click();
                    }}
                  >
                    <i className="fa fa-plus" />
                    Add Attachment
                  </button>

                  {attachments.length > 0 && (
                    <div className="ccar-attachment-list">
                      {attachments.map(
                        (file, index) => (
                          <div
                            key={`${file.name}-${file.lastModified}-${index}`}
                            className="ccar-attachment-item"
                          >
                            <div>
                              <i className="fa fa-paperclip" />

                              <span>
                                {file.name}
                              </span>
                            </div>

                            <button
                              type="button"
                              className="ccar-remove-btn"
                              disabled={
                                isSubmitting
                              }
                              onClick={() =>
                                removeAttachment(
                                  index,
                                )
                              }
                              aria-label={`Remove ${file.name}`}
                            >
                              <i className="fa fa-trash" />
                            </button>
                          </div>
                        ),
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="epr-submit-action-btn">
            <button
              type="submit"
              className="epr-submit-request"
              disabled={isSubmitting}
            >
              <span className="epr-form-btn-txt">
                {isSubmitting
                  ? "Submitting..."
                  : "Submit Request"}
              </span>

              {isSubmitting && (
                <img
                  src={loader2}
                  alt="Submitting request"
                  className="epr-form-loader"
                  style={{
                    display: "inline-block",
                  }}
                />
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CcarForm;